import React from 'react';

const TwitterHoverBlueLogo = ({ ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.3438 4.25C14.9688 3.78125 15.5313 3.21875 16 2.53125C15.375 2.8125 14.75 3 14.125 3.0625C14.8125 2.625 15.3125 2.03125 15.5625 1.25C14.9063 1.625 14.2188 1.90625 13.4688 2.03125C13.1563 1.71875 12.7813 1.46875 12.375 1.28125C11.9688 1.09375 11.5313 1 11.0625 1C10.4688 1 9.9375 1.15625 9.4375 1.4375C8.9375 1.75 8.53125 2.15625 8.25 2.65625C7.9375 3.15625 7.8125 3.71875 7.8125 4.28125C7.8125 4.53125 7.8125 4.78125 7.875 5.03125C6.53125 4.96875 5.28125 4.65625 4.09375 4.03125C2.90625 3.4375 1.9375 2.625 1.125 1.59375C0.8125 2.125 0.65625 2.6875 0.65625 3.25C0.65625 3.8125 0.78125 4.34375 1.0625 4.8125C1.3125 5.3125 1.6875 5.6875 2.125 6C1.59375 6 1.09375 5.84375 0.65625 5.5625V5.625C0.65625 6.40625 0.90625 7.09375 1.40625 7.6875C1.90625 8.3125 2.53125 8.6875 3.28125 8.84375C2.96875 8.90625 2.6875 8.9375 2.40625 8.9375C2.21875 8.9375 2 8.9375 1.8125 8.90625C2 9.5625 2.375 10.0938 2.9375 10.5312C3.5 10.9688 4.125 11.1562 4.875 11.1562C3.65625 12.0938 2.28125 12.5625 0.78125 12.5625C0.46875 12.5625 0.21875 12.5625 0 12.5313C1.5 13.5313 3.1875 14 5.03125 14C6.9375 14 8.625 13.5313 10.125 12.5313C11.4688 11.6562 12.5313 10.5 13.2813 9C14 7.625 14.375 6.15625 14.375 4.65625C14.375 4.46875 14.3438 4.34375 14.3438 4.25Z"
      fill="#2277D1"
    />
  </svg>
);

export default TwitterHoverBlueLogo;
